import { SecurityOptionType } from '@module/assignment';
export function getSecurityRuleLabels(t, context) {
  return {
    copyPaste: t("securityRules.".concat(context, ".copyPaste")),
    tabSwitch: t("securityRules.".concat(context, ".tabSwitch")),
    other: t("securityRules.".concat(context, ".other"))
  };
}
export function getSecurityRuleLabel(id, labels, fallback) {
  switch (id) {
    case SecurityOptionType.copyPaste:
      return labels.copyPaste;

    case SecurityOptionType.outOfFocusTab:
      return labels.tabSwitch;

    default:
      return (fallback === null || fallback === void 0 ? void 0 : fallback.trim()) || labels.other;
  }
}